// @ts-check
"use strict";

/** @typedef {import("./activityTypes").ActivityTypeName} ActivityTypeName */
/** @typedef {import("./activityTypes").FeatureActivityKindName} FeatureActivityKindName */

// null means no activity type decided yet. The backend keeps a copy for weekly goal progress: ACTIVITY_TYPE_BY_FEATURE_KIND in backend/src/lib/activityContent.ts.
/** @type {Readonly<Record<FeatureActivityKindName, ActivityTypeName | null>>} */
const ACTIVITY_TYPE_BY_FEATURE_KIND = {
  ANNUAL_HISTORY: "COGNITIVE",
  HOROSCOPE: "COGNITIVE",
  ENDLESS_QUIZ: "COGNITIVE",
  CHAT: "SOCIAL_AND_COMMUNICATIVE",
  VIDEOCHAT: "SOCIAL_AND_COMMUNICATIVE",
  CONVERSATION_GUIDE: null,
  ASSESSMENT: null,
  QUESTIONNAIRE: null,
  PHOTO_ALBUM: null,
};

/**
 * @param {string | null | undefined} kind
 * @returns {ActivityTypeName | null}
 */
function activityTypeForFeatureKind(kind) {
  if (!kind || !Object.prototype.hasOwnProperty.call(ACTIVITY_TYPE_BY_FEATURE_KIND, kind)) {
    return null;
  }
  return ACTIVITY_TYPE_BY_FEATURE_KIND[/** @type {FeatureActivityKindName} */ (kind)];
}

module.exports = {
  ACTIVITY_TYPE_BY_FEATURE_KIND,
  activityTypeForFeatureKind,
};
